import Input from './Input';

export default Input;


//////////////////
// WEBPACK FOOTER
// ./~/element-react/dist/npm/es6/src/input/index.js
// module id = 22
// module chunks = 0